var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-8xl mx-auto h-full -mt-6 lg:-mt-8",style:(_vm.style)})}
var staticRenderFns = []

export { render, staticRenderFns }